/**
 * Hands a download URL to the browser the way every page used to by hand: a
 * transient anchor click. The browser follows the server's redirect and
 * attachment headers; `filename` is only a hint (ignored cross-origin).
 */
export default function startBrowserDownload(url, filename) {
    const link = document.createElement('a');
    link.href = url;
    if (filename) link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
